import React from "react";
import {useSelector} from "react-redux";
import {toVND} from "../../helpers/helpers";

export interface CartIconProps {
    onClick?: () => void;
}

const CartIcon = ({onClick}: CartIconProps) => {
    const cart = useSelector((state: any) => state.Cart);

    const totalQuantity = cart.items.reduce(
        (sum: number, item: any) => sum + (item.quantity || 0),
        0
    );

    return (
        <React.Fragment>
            {cart.items.length > 0 && (
                <div
                    className="position-fixed end-5 bottom-2 rounded-pill bg-white shadow btn btn-icon p-2 z-2"
                    role="button"
                    tabIndex={0}
                    onClick={onClick}
                    onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            onClick?.();
                        }
                    }}
                >
                    <div className="btn-primary rounded-pill btn btn-icon p-1 me-1">
                        <div className="cart-icon-wrap cart-icon-wrap-custom">
                            <i className="mdi mdi-cart text-white font-15"></i>
                            <span className="font-15">{totalQuantity}</span>
                        </div>
                    </div>
                    <span className="font-14 fw-semibold">
                        {toVND(cart.total)}
                    </span>
                </div>
            )}
        </React.Fragment>
    );
};

export default CartIcon;
